export const access = {
pages:{
GPSERVICE:"GENERAL_PACKAGE_MST",
NEWREG : "PG_PAT_REG_MST",
ABHAREG :"REG_ABHA",
ABHAPHY:"PHYSICIAN_ABHA",
ABHABRANCH:"BRANCH_ABHA",
ABHAMEDMST:"MEDICINE_ABHA",
ABHAPRES:"PRESCRIPTION_ABHA",
ABHAAPPOINTMENT:"APPOINTMENT_ABHA",
ABHAOTBOOK:"OT_BOOKING_ABHA",
ABHAUNITMST:"UNIT_MST_ABHA",
ABHADEPT:"DEPARTMENT_MST_ABHA",
ABHASURGERYMST:"OT_SUR_MST_ABHA",
ABHATREATMENTPLAN:"TREAT_PLAN_MST_ABHA",
ABHAEHRDASHBOARD:"EHR_DASHBOARD_ABHA",
ABHASERVICEMST:"SERVICE_MST_ABHA",
ABHAALLERGY:"ALLERGY_ABHA",
ABHACHIEFCOMPMST:"CHIEFCOMPLAINT_ABHA",
ABHASOCIALHABITS:"SOCIAL_HABITS_ABHA",
ABHADIAGNOSISMST:"DIAGNOSIS_MST_ABHA",
ABHAVACCINE:"VACCINE_MST_ABHA",
ABHALAB:"LAB_ABHA",
ABHAIPBilling:"ABHA_IP_BILL",
ABHAOPBilling:"ABHA_OP_BILL",
ABHAPharmacy:"ABHA_PHARM",
ABHADischargeSummary:"ABHA_DISCHARGE_SUM",
ABHARadiology:"ABHA_RADIOLOGY",

DECEASEDREG:"PG_PAT_ADM_ACCESS",
TASKORDERCOUNSELLING:"Task_Counselling",


APPTLIST : "PG_APP_LIST",
//New Page Access Declare By RAJA 11-11-21
MEDICALTOURISM:"PG_PAT_MED_TOUR_MST",
REGATTACH:"PG_PAT_DOC_MST",
OPBILLTRNS:"PG_OP_BILL_TRANS",
RECEIPTRNS:"PG_RECEIPT_TRANS",
PENDINGBILLLIST:"PG_OP_PENDING_BILL_LIST",
ACCPAYMT:"PG_PAYMENT_TRANS",
SUPPAYMT:"PG_SUPPLIER_PAY_TRANS",
EHRCHIEFCOMPMST:"PG_EHR_CHIEF_COMPLAINT_MST",
EHRMEDICALHISTORYMST:"PG_EHR_MEDICAL_HISTORY_MST",
EHRSOCIALHABITSMST:"PG_EHR_SOCIAL_HABITS_MST", 
EHREXAMMST:"PG_EHR_EXAM_MST",
EHRINSTRUCTIONSMST:"PG_EHR_INSTRUCTIONS_MST",
EHRDIETPLANMST:"PG_EHR_DIET_PLAN_MST",
EHRTRAININGCLASSMST:"PG_EHR_TRAINING_CLASS_MST",
EHRTREATPLANMST:"PG_EHR_TREAT_PLAN_MST", 
EHRDASHBOARD:"PG_EHR_DASHBOARD",
EHRMEDICALHISTORYTRANS:"PG_EHR_MEDICAL_HISTORY_TRANS",
EHROPCASESHEET:"PG_EHR_OP_CASE_SHEET",
EHROPADVCASESHEET:"PG_EHR_OP_ADV_CASE_SHEET",
THERAPYTRANS:"PG_THERAPY_TRANS",

RPTOPBILLCOLLECTIONDAILY:"PG_RPT_OP_BILL_COLLECTION_DAILY",
RPTOPBILLCOLLECTIONSRVCCATEGORY:"PG_RPT_OP_BILL_COLLECTION_SRVC_CATEGORY",
RPTBILLCOLLECTIONSRVCCATEGORY:"PG_RPT_BILL_COLLECTION_SRVC_CATEGORY",
RPTOPCOLLECTION:"PG_RPT_OP_COLLECTION",
RPTDOCTORREVENUE:"PG_RPT_DOCTOR_REVENUE",
RPTDEPARTMENTREVENUE:"PG_RPT_DEPARTMENT_REVENUE",
RPTOPRECEIPTSUMMARY:"PG_RPT_OP_RECEIPT_SUMMARY",
RPTSERVICECATEGORY:"PG_RPT_SERVICE_CATEGORY",
RPTMEDICALHISTORY:"PG_RPT_MEDICAL_HISTORY",
RPTREFERRAL:"PG_RPT_REFERRAL",
RPTWARD:"PG_RPT_WARD",
RPTBED:"PG_RPT_BED",
RPTBUILDING:"PG_RPT_BUILDING",
RPTROOM:"PG_RPT_ROOM",
RPTFLOOR:"PG_RPT_FLOOR",
RPTNURSINGCOUNTER:"PG_RPT_NURSING_COUNTER", 
IPRPTCOLLECTION:"PG_IP_RPT_COLLECTION",
IPRPTADVANCESUMMARY:"PG_IP_RPT_ADVANCE_SUMMARY",
COMMUNICATION:"PG_AUTO_MSG_DET_MST",

TEMPLATEMST:"PG_TEMPLATE_MST",
TMPLCERTIFICATEMST:"PG_TMPL_CERTIFICATE_MST",
TMPLCONSENTMST:"PG_TMPL_CONSENT_MST",
TMPLDAYCARESUMMMST:"PG_TMPL_DAYCARE_SUMM_MST",

//End Page Access Declare By RAJA 16-11-21
// Abirami P declration
PHYMST:"PG_PHY_MST",
PHYCONFMST:"PG_PHY_CONF_MST",
PHAPPLIST:"PG_APP_LIST",
PHSCHDULEMST:"PG_PHY_SCHEDULE_MST",
PHAPPBOOK:"PG_APP_BOOK_TRANS",
PHAPPQUEUELIST:"PG_PAT_APP_QUEUE_LIST",
PGLAUNMST:"PG_LAUN_MSTR",
PGLAUNISSUED:"PG_LAUNDRY_ISSUE_TRANS",
PGPACKAGEMST:"PG_PACKAGE_MST",
PGPACKAGEMODULEMST:"PG_PACKAGE_MODULE_MST",
PGTASKMST:"PG_TASK_MST",
PGTASKACTIONMST:"PG_TASK_ACTION_MST",
PGMODULEMST:"PG_MODULE_MST",
PGPAGEEMST:"PG_PAGE_MST",
PGSUBSCRIBTIONTRANS:"PG_MY_SUBSCRIPTION_TRANS",
PGUSERTRANS:"PG_USER_TRANS",
PGROLETRANS:"PG_ROLES_TRANS",
PGBRANCHLIST:"PG_BRANCH_LIST",
PGBRANCHTRANS:"PG_BRANCH_TRANS",
PGTENANTTRANS:"PG_TENANT_TRANS",
PGMEDMST:"PG_MED_MST",
PGPHARMMST:"PG_PH_PHARMACY_MST",
PGSTORAGEMST:"PG_PH_STORE_SHELVE_MST",
PGSTOREMST:"PG_PH_STORE_MST",
PGSUPLRMST:"PG_PH_SUPPLIER_MST",
PGMEDMSTGSTUPDATE:"PG_PH_MED_GST_UPDATE",

PGCUSTOMERMST:"PG_CUSTOMER_MST",
PGDEPARTMENTMST:"PG_DEPT_MST",
PGDESIGNINGMST:"PG_DESG_MST",
PGEXPANSEMST:"PG_EXPENSE_MST",
PGHOSPCONFMST:"PG_HOSP_CONF_MST",
PGCLIINSTRUCTIONSMST:"PG_CLI_INSTRU_MST",
PGPAYARMST:"PG_PAYER_MST",
PGPRNCONFMST:"PG_PRN_CONF_MST",
PGREFMST:"PG_REF_MST",
PGSERVDETMST:"PG_SRVC_DET_MST",
PGSRVCMST:"PG_SRVC_MST",
PGSRVCCATMST:"PG_SRVC_CAT_MST",
PGSRVCSUBCATMST:"PG_SRVC_SUB_CAT_MST",
PGSHIFTMST:"PG_SHIFT_MST",
PGBANKMST:"PG_BANK_MST",
PGCOUNTRYMST:"PG_CTRY_MST",
PGCREDITNOTEREASON:"PG_CREDIT_NOTE_REASON",
PGDIAGNOSISMST:"PG_DIAGNOSIS_MST",
PGDISTRICTMST:"PG_DISTRICT_MST",
PGLEAVEMST:"PG_LEAVE_MST",
PGMEDICINEGENERICSMST:"PG_MED_GENERICS_MST",
PGHIGHRISKMST:"PG_HIGH_RISK_MST",
PGINSTITUTIONMST:"PG_INSTITUTION_MST",
PGLANGUAGEMST:"PG_LANG_MST",
PGMEDICINEMANUFACTURERMST:"PG_MED_MFR_MST",
PGMEDICINECATEGORYMST:"PG_MED_CAT_MST",
PGPURCHASERETURNREASONMST:"PG_PUR_RTN_REASON",
PGQUALIFICATIONMST:"PG_QUALIFICATION_MST",
PGSALESRETURNREASONMST:"PG_SAL_RTN_REASON",
PGUPIPAYMENTMODEMST:"PG_UPI_PAY_MODE_MST",
PGVACCINEMST:"PG_VACCINES_MST",
PGVACINEAGEDESCMST:"PG_VACCINES_CONFIG_MST",
PGVACCINEBRANDMST:"PG_VACCINES_BRAND_MST",
PGVACCINESETTINGSMST:"PG_PAT_VACCINES_SETTINGS",
PGPEADIATRCCASESHEETTRANS:"PG_PAEDIATRCS_CASESHEET",
PGVIDEOCONSULTRANS:"PG_VIDEO_CONSULT_TRANS",
PGRECORDINGTRANS:"PG_VIDEO_RECORDING_TRANS",
PGJOBCATEGORYMST:"PG_JOB_CAT_MST",
PGADMINDASHBOARD:"PG_ADMIN_DASHBOARD",
STATEMST : "PG_STATE_MST",
COUNCILMST : "PG_COUNCIL_MST",
ADMTYPE : "PG_ADM_TYPE_MST",
BEDMST :"PG_BED_MST",
BUILDINGMASTER :"PG_BUILDNG_MST",
NURSINGCOUNTER:"PG_NUR_COUNTR_MST",
ROOMMASTER:"PG_ROOM_MST",
WARDMASTER:"PG_WARD_MST",
FLOORMASTER:"PG_FLR_MST",
BEDVIEW:"PG_IP_BED_VIEW_LIST",
DIETPLAN:"PG_IP_DIET_PLAN_MST",
DISREASON:"PG_DISG_REASON_MST",
ADMMST:"PG_IP_ADM_MST",
DEFAULTWARDBASEDSERVICE:"PG_DEFAULT_WARD_BASED_SRVC",

PGINDENTREQUEST:"PG_PH_INDENT_REQUEST",
PGINDENTAPPROVAL:"PG_PH_INDENT_APPROVAL",
PGIDENTISSUE:"PG_PH_INDENT_ISSUE",
PGINDENTRECEIVE:"PG_PH_INDENT_RECEIVE",
PGPURCHASEORDER:"PG_PH_PUR_ORDER",
PGPURCHASEORDERAPPROVAL:"PG_PH_PUR_APPROVAL",

   //OBS GYNC *ANANDH RAVICHANDRAN
    TRAININGCLASS:"PG_TRAINING_TRANS",
    BOOKLET : "PG_OBG_BOOKLET_TRANS",
    OBSDASHBOARD : "PG_OBG_DASHBOARD",
    MENHISTORY:"PG_MENSTURAL_HIST_TRANS",
    HIGHRISK:"PG_OBG_HIGH_RISK_TRANS", 
EMPLOEEMST:'PG_EMP_MST',
//Pharmacy - Implemented by Thenmozhi
PURCHASE : "PG_PH_PUR_TRANS",
PG_PH_PUR_ORDER_APPROVAL:"PG_PH_PUR_ORDER_APPROVAL",
PURCHASERETURN : "PG_PH_PUR_RET_TRANS",
SALESDASHBOARD : "PG_PH_SALES_DASHBOARD",
SALES : "PG_PH_SALES_TRANS",
SALESRETURN : "PG_PH_SALES_RET_TRANS",
STOCKLIST : "PG_PH_STOCK_LIST",
EXPIRYLIST: "PG_PH_EXPIRY_LIST",
LOWSTOCKLIST: "PG_PH_LOW_STOCK_LIST",
EXCESSSTOCKLIST: "PG_PH_EXCESS_STOCK_LIST",
OPENINGSTOCK: "PG_PH_OPEN_STOCK_MST",
PHARMACYCREDITBILL : "PG_PH_CREDIT_BILL_TRANS",
PHARMACYRECEIPT : "PG_PH_RECEIPT_TRANS",
SUPPLIERDUES : "PG_PH_SUPPLIER_DUE_LIST",
PHARMACYSUPPLIERPAYMENT : "PG_PH_SUPPLIER_PAYMENT_TRANS",
OPENSTOCKFILEUPLOAD:'OPENING_STOCK_UPLOAD',
OLDPURCHASE:'PG_PH_PUR_OLD_ENTRY',

//Dental - Thenmozhi
DENTALPROBLEM : "PG_TEETH_PROBLEMS_MST",
DENTALPROCEDURES: "PG_TEETH_PROCEDURES_MST",
DENTALCASESHEET : "PG_TEETH_CASESHEET_MST",

//Pharmacy Reports
PURCHASEREPORT:"PG_RPT_PH_PURCHASE",
PURCHASERETRUNREPORT:"PG_RPT_PH_PURCHASE_RETURN",
SALESREPORT:"PG_RPT_SALES",
SALESRETURNREPORT:"PG_RPT_SALES_RETURN",
CONSOLIDATEDSALES:"PG_RPT_CONSOLIDATED_SALES",
CONSOLIDATEDPURCHASE:"PG_RPT_CONSOLIDATED_PURCHASE",
CLOSINGSTOCKREPORT:"PG_RPT_CLOSING_STOCK",
STOCKUPDATEHISTORY:"PG_RPT_STOCK_UPDATE_HISTORY",
PRODUCTWISESALESREPORT:"PG_RPT_PRODUCT_SALES",
SCHEDULEHREPORT:"PG_RPT_SCHEDULE_H",
PURCHASEABSTRACT:"PG_RPT_PURCHASE_ABSTRACT",
STOCKTRANSACTIONREPORT:"PG_RPT_STOCK_TRANS",
USERTYPEMST : "PG_USER_TYPE",
UNITMST : "PG_UNIT_MST",
//Anupama
WARDFACILITIESMST : "PG_WARD_FACIL_MST",
MEDICALCERTIFICATE : "PG_CERTIFICATE_TRANS",

//Abirami
BEDTRANS:"PG_IP_BED_TRANS",
DISADV:"PG_IP_DISG_ADVICE_TRANS",
DISENTRY:"PG_IP_DISG_ENTRY_TRANS",
DISSUM:"PG_IP_DISG_SUM_TRANS",
IPVITAL:"PG_IP_VITAL_TRANS",
IPNURSENOTES:"PG_IP_NURSE_NOTES_TRANS",
IPINTAKEOUTPUT:"PG_IP_INTAKE_OUTPUT_TRANS",
IPDOCTORNOTES:"PG_IP_DOCTOR_NOTES_TRANS",
IPPRES:"PG_IP_MED_PRES_TRANS",
IPMEDINTAKE:"PG_IP_MED_INTAKE_TRANS",
ASSETTYPE:"PG_ASSET_TYPE_MST",
ASSETMST:"PG_ASSET_MST",
LABCAT:"PG_LAB_CAT_MST",
LABGRP:"PG_LAB_GROUP_MST",
LABPKG:"PG_LAB_PACK_MST",
LABTST:"PG_LAB_TEST_MST",
LABMAT:"PG_TASK_LAB_SPEC_MST",
LABMET:"PG_TASK_LAB_MET_MST",
LABQUEUE:"PG_TASK_LAB_QUE_DASH_TRANS",
LABORDERLIST:"PG_LAB_WORK_ORDER_LIST",
LABRESULTENTRY:"PG_TASK_LAB_RES_TRANS",
RADQUEUE:"PG_RAD_PAT_QUEUE_LIST",
RADLIST:"PG_RAD_WO_LIST",
ADVPAY:"PG_ADVANCE_TRANS",
IPBILL:"PG_IP_BILL_TRANS",
IPBILLSERVICES:"PG_IP_BILL_SRVC_TRANS",
ROOMRENT:"PG_IP_ROOM_RENT_TRANS",
REPORTMENU:"PG_REPORT_MENU",

// CEA Reports
ADMSNDISCREG:"PG_IP_ADM_DISG_CEA",
IMAGINGREG:"PG_RAD_IMG_CEA",
LABREG:"PG_LAB_CEA",
PATIENTREG:"PG_PAT_REG_CEA",

//Inventory - Page
ITEMCATEGORY:"PG_ITEM_CAT_MST",
ITEMMANUFACTURER:"PG_ITEM_MFR_MST",
ITEMLOCATION:"PG_ITEM_LOCATION_MST",
ITEMTYPE:"PG_ITEM_TYPE_MST",
ITEMMST:"PG_ITEM_MST",


// patient-list

CLINICALDASH:"PG_IP_CLINICAL_WORKLIST_DASHBOARD",
DEATHREG:"PG_OP_DEATH_REGISTER_TRANS",

//OT -Master
OTCOUNTMST:"PG_OT_COUNT_MST",
OTCHECKLISTMST:"PG_OT_CHECKLIST_MST",
OTIMPLANTSMST:"OT_IMPLANTS_MST",
OTSURGERYMST:"OT_SURGERY_MST",
OTTABLEMST:"OT_TABLE_MST",
CSSDITEMMST:"OT_CSSD_ITEM_MST",

//Asset
ASSETSUBTYPE:"PG_ASSET_SUB_TYPE_MST",

// OT Transactions by Abirami P
OTBOOKMST:"PG_OT_BOOK_MST",
OTSCHEDULEMST:"PG_OT_SCHEDULE_MST",
OTNOTESMST:"PG_OT_NOTES_MST",
OTREPORTSMST:"PG_OT_REPORTS_MST",

// Marketing Leads by RAJA
MARKTLEADS:"PG_LEADS_MST",
//IP - DischargeList
DISCHARGELIST:"PG_IP_DISG_LIST",
//Santhiya
PATREFERRALLIST:"PG_PAT_REFERRAL_LIST",
REVENUESHARELIST:"PG_REVENUE_SHARE_LIST",
REVENUESHARECONFIG:"PG_REVENUE_SHARE_CONFIG",

// patient-wallet by Abirami.P
PGPATWALLETTRANS:"PG_PAT_WALLET_TRANS",
PGWALLETTRANSLIST:"PG_WALLET_TRANS_LIST",

PGCOMBINEDVACCINE:"COMBO_VACCINE_MST",

// op hold bill
PGOPHOLDBILL:"PG_OP_HOLD_BILL_LIST",
COMVACCMAD:"COM_VACC_SCHEDULE",

//Visit Mode Mst Declare By Thenmozhi 29-01-2022
VISITMODEMST:"VISIT_MODE_MST",
PGBANKTRANS:"PG_BANK_TRANS",

// Lab Reports:
PGTATREPORT:"PG_TAT_REPORT",
PGSTAREPORT:"PG_STA_REPORT",
PGDOCINVREVREPORT:"PG_DOC_INV_REV_REPORT",
//Accounts Reports:
CANCELADVLIST:"PG_CANCEL_ADV_LIST",
CREDITBILLSELF:"PG_CREDIT_BILL_SELF",
RECEIPTLISTSELF:"PG_RECEIPT_LIST_SELF",
CANCELLEDBILLLISTBOTHOPIPPAGE:"CANCELLED_BILL_LIST_BOTH_OP_IP_PAGE",
//Analytics-Thenmozhi
ANALYTICS:"PG_ANALYTICS",

//Lab Reports
PG_EDIT_LOG_REPORT:"PG_EDIT_LOG_REPORT",
PG_INHOUSE_OUTSOURCE_REPORT:"PG_INHOUSE_OUTSOURCE_REPORT",
PGLABREVCOLLECTIONREPORT:"PG_LAB_REV_COOLECTION_REPORT",
PGLABCOLLECTIONBYDATE:"PG_LAB_COLLECTION_BY_DATE",
PGLABCOLLECTIONBYSERVICE:"PG_LAB_COLLECTION_BY_SERVICE_TYPE",
// IP hold bill:-
PGIPHOLDBILL:"PG_IP_HOLD_BILL_LIST",

// SMS related page:-
PGCONTENTMGMTLIST:"PG_CONTENT_MGMT_LIST",
PGSMSCREDITPAGE:"PG_SMS_CREDIT_PAGE",
PGTEMPLATEPURCHASEPAGE:"PG_TEMPLATE_PURCHASE_PAGE",
PGGATEWAYCONFIGURATIONPAGE:"PG_GATEWAY_CONFIGURATION_PAGE",

// Collection Reports IP:-
PGIPBILLCANCELLEDREPORT:"PG_IP_BILL_CANCELLED_REPORT",
PGIPADVANCECANCELLEDSUMMARYREPORT:"PG_IP_ADVANCE_CANCELLED_SUMMARY_REPORT",
PGIPCOLLECTIONSERVICEWISEREPORT:"PG_IP_COLLECTION_SERVICE_WISE_REPORT",
PGIPSERVICECATEGORYREPORT:"PG_IP_SERVICE_CATEGORY_REPORT",

// Collection Reports OP:-
PGOPBILLCANCELLEDREPORT:"PG_OP_BILL_CANCELLED_REPORT",
PGOPSERVICEWISEREPORT:"PG_OP_SERVICE_WISE_REPORT",
// Walkin Module (Direct Patient Billing):-
WALKINPATIENTREGISTRATIONPAGE:"WALKIN_PATIENT_REGISTRATION_PAGE",
WALKINPATIENTBILLINGPAGE:"WALKIN_PATIENT_BILLING_PAGE",
WALKINPATIENTCANCELLEDBILLLISTPAGE:"WALKIN_PATIENT_CANCELLED_BILL_LIST_PAGE",

//IP Statistic Report - Santhiya
CONSOLIPREPORTDEPT: "CONSOLIDATED_IP_REPORT_DEPT",
MONTHCONSOLIPREPORTDEPT:"MONTHWISE_CONSOLIDATED_IP_REPORT_DEPT",
CONSOLIPREPORTWARD:"CONSOLIDATED_IP_REPORT_WARD",
MONTHCONSOLIPREPORTWARD:"MONTHWISE_CONSOLIDATED_IP_REPORT_WARD",
CONSOLIPREPORTPHY:"CONSOLIDATED_IP_REPORT_PHYSICIAN",
MONTHCONSOLIPREPORTPHY:"MONTHWISE_CONSOLIDATED_IP_REPORT_PHYSICIAN",
CONSOLIPREPORTADMTYPE:"CONSOLIDATED_IP_REPORT_ADMTYPE",
MONTHCONSOLIPREPORTADMTYPE:"MONTHWISE_CONSOLIDATED_IP_REPORT_ADMTYPE",

//Lab Barcode Template
PGBARCODETEMPLATE:"BARCODE_TEMPLATE",
//Lab Equipment Machine
PGLEM:"PG_LEM",
//UnBilled Service&Service Category
PGIPUNBILLEDSERVICEREPORT:"PG_IP_UNBILLED_SERVICE_WISE_REPORT",
PGIPUNBILLEDSERVICECATEGORYREPORT:"PG_IP_UNBILLED_SERVICE_CATEGORY_REPORT",

//Lab statistic count report
LAB_STATISTIC_COUNT : "LAB_STATISTIC_COUNT" , 
//Lab Report (Lab Patient Package Report)
LAB_PACKAGE_PATIENT_DETAILS : "LAB_PACKAGE_PATIENT_DETAILS",

DOC_STATISTICS:"DOC_STATISTICS",

//DayBook
DayBookCon:"DAYBOOK_CONSOLIDATED_PAGE",
DayBookDet:"DAYBOOK_DETAILED_PAGE",

//Overall collection Summary
OverallCollSumCon:"OVERALL_COLL_SUMM_CONSOLIDATED_PAGE",
OverallCollSumDet:"OVERALL_COLL_SUMM_DETAILED_PAGE",
//Accounts Group Master
ACCOUNTSGROUPMST:"ACCOUNTS_GROUP_MST",

//Others Income:-
OTHERINCOMELIST:"OTHER_INCOME_LIST",
//EHR Report:-
EHRREPORT:"EHR_REPORT",

// Inventory module:-
PGITEMSALESMST:"PG_ITEM_INDENT_MST",
PGITEMINDENTREQUEST:"PG_ITEM_INDENT_MST",
PGITEMINDENTAPPROVAL:"PG_ITEM_INDENT_APPROVE_MST",

PGWAREHOUSEMST:"PG_WAREHOUSE_MST",
PGQCREASONMST:"PG_QC_REASON_MST",
PGSCRAPREASONMST:"PG_SCRAP_REASON_MST",
PGCREDITNOTEREASONMST:"PG_CREDIT_NOTE_REASON_MST",
PGINTDEPTMST:"PG_INT_DEPT_MST",
PGDEBITNOTEREASONMST:"PG_DEBIT_NOTE_REASON_MST",

CAMPMASTER:"CAMP_MST",
CAMPPATIENTLIST:"CAMP_PATIENTS",

//OPD Setup by Raja 2022-11-09 :)
OPDSEQUENCEGENERATOR:"OPD_SEQUENCE_GENERATOR",
OPDMONITORSETUP:"OPD_MONITOR_SETUP",
INVENTORYPURCHASE:"PG_ITEM_PUR_MST",
INVENTORYPURCHASERETURN:"PG_ITEM_PUR_RETURN_MST",
INVENTORYPURCHASEORDER:"PG_ITEM_PUR_ORD_MST",
ITEMSCRAPENTRY:"PG_ITEM_SCRAP_ENTRY_MST",
ITEMOPENINGSTOCK:"PG_ITEM_OPEN_STOCK_LIST",
CREDITNOTEENTRY:"PG_ITEM_CREDIT_NOTE_ENTRY_MST",
DEBITNOTEENTRY:"PG_ITEM_DEBIT_NOTE_ENTRY_MST",
ITEMSTOCKLIST:"PG_ITEM_STOCK_LIST",
INTERNALDEPTSTOCK:"PG_ITEM_INT_DEPT_STOCK_LIST",
SUPLIERDASHBOARD:"PG_ITEM_SUP_DASHBOARD_MST",
INVENTORYSUPPLIERDUES:"PG_ITEM_SUP_DUES_MST",
WAREHOUSEREPORT:"PG_ITEM_WAREHOUSE_STOCK_LIST",

//IP-Patient-Monitoring, by Anandaraj
PATIENTMONITORING:"PG_PATIENT_MONITORING",


//Patient Package Module PageID

PATIENTPACKAGE:"PATIENT_PACKAGE",


//Blood Bank Module PageID
BLOODDASHBOARD:"BLOOD_DASHBOARD",
BLOODDONOR:"BLOOD_DONOR",
BLOODCOLLECTION:"BLOOD_COLLECTION",
BLOODREQUEST:"BLOOD_REQUEST",
BLOODSTOCKLIST:"STOCK_LIST",
BLOODOPENINGSTOCK:"OPENING_STOCK",
BLOODDISCARD:"BLOOD_DISCARD",
BLOODRETURN:"BLOOD_RETURN",
BLOODTRANSFUSION:"BLOOD_TRANS",

//Pharmacy Credit Note - by Anandaraj M
PHCREDITNOTE:"PG_PH_CREDIT_NOTE",
//Pharmacy Purchase Return Adjustment - by Anandaraj M
PHPURETURNADJT:"PG_PH_PUR_RTN_ADJUST",

//Payer
PAYERDASHBOARD:"PAYER_DASHBOARD",

//Lab Queue Page
LABQUEUE_NEW:"LAB ORDER QUEUE - NEW LIST",
LABQUEUE_SAMPLE:"LAB ORDER QUEUE - SAMPLE COLLECTED LIST",
LABQUEUE_RESULTENTRY:"LAB ORDER QUEUE - RESULT ENTRY LIST",
LABQUEUE_APPROVAL:"LAB ORDER QUEUE - WAITING FOR APPROVAL LIST",
LABQUEUE_COMPLETED:"LAB ORDER QUEUE - COMPLETED LIST",
Lab_Result_Edit:"Lab_Result_Edit",

//Assessment - By Mageshwaran
ASSESSMENTTEMPLATEGENERATOR:"ASS_Template_Generator",
IPASSESSMENTTEMPLATETRANSACTION:"ASS_Template_Transaction",
OPASSESSMENTTEMPLATETRANSACTION:"OP_ASS_Template_Transaction",
SCORINGTABLE:"ASS_Scoring_Table",
NURSEHANDOVER:"Nurse_Hand_Over",

//VOPD
USERDASHBOARD:'VOPD_QUEUE_LIST',
PATIENTQUEUE :'VOPD_PATIENT_QUEUE',
TRIAGEQUEUE :'VOPD_TRIAGE_QUEUE',
LABQUEUEVOPD :'VOPD_LAB_QUEUE',
RADIOLOGYQUEUE :'VOPD_RADIOLOGY_QUEUE',
PHARMACYQUEUE :'VOPD_PHARMACY_QUEUE',
PHYSICIANQUEUE :'VOPD_PHYSICIAN_QUEUE',

REFREPORT:'REPORT_REFERRAL',
APPTREMAINDER:'APP_REMINDER',
IPREPORT:'REPORT_IP',

//Emergency
EMERGENCYDASHBOARD:'PG_EMERGENCY_MENU',
LABRESAMPLELIST: 'Lab_Resampled_List',

//CRM
ENQUIRYSTATUSMASTER:'Enquiry_Status_Master',
ENQUIRYMASTER:'Enquiry_Master',
SALESQUOTE:'Sales_Quote',
SALESINVOICE:'Sales_Invoice',
CRMRECEIPT:'Receipt',
//BackDated
BACKDATEDREGISTRATION: 'Backdated_Registration',
BACKDATEDADMISSION:'Backdated_Admission',

//Asset by Magesh 
ASSETREGISTER:'Asset_Register',
AMCRENEWAL:'AMC_Renewal_List',
RENTALRENEWAL:'Rental_Renewal_List',

//Approval
APPROVALOPBill:'OP_Bill',
APPROVALQUEUELIST:'Approval_Queue_List',
REGISTRATION: 'Registration',
ADMISSION: 'Admission',
COMPLETEDAPPROVAL: 'Completed_Approval',
REJECTEDAPPROVAL: 'Rejected_Approval',

PATIENTINDENTMONITORING:'Patient_Indent_Monitoring',
PATIENTCAREENTRY:'Patient_Care_Entry',
TASKORDER:'Task_Order',

//MV CaseSheets
//Dental
DENTAL_EXAMINATION:'DENTAL_EXAMINATION',

//Podiatry
POD_WOUNDCARE:'POD_WOUNDCARE',

//Psychology
PSY_PSYCHOLOGYEXAMINATION  :'PSY_PSYCHOLOGYEXAMINATION',

//Ophthalmology
IP_OPHTH_EYE_PREOT:'IP_OPHTH_EYE_PREOT',
OP_OPHTH_EYE_PREOT:'OP_OPHTH_EYE_PREOT',
IP_OPHTH_EYE_POSTOT:'IP_OPHTH_EYE_POSTOT',
OP_OPHTH_EYE_POSTOT:'OP_OPHTH_EYE_POSTOT',
OP_OPHTH_EYE_IOL:'OP_OPHTH_EYE_IOL',
IP_OPHTH_EYE_IOL:'IP_OPHTH_EYE_IOL',
IP_OPHTH_EYE_POSTFOLLOWUP:'IP_OPHTH_EYE_POSTFOLLOWUP',
OP_OPHTH_EYE_POSTFOLLOWUP:'OP_OPHTH_EYE_POSTFOLLOWUP',
OPHTH_SPECS:'OPHTH_SPECS',
OPHTH_REFRACTION:'OPHTH_REFRACTION',
OPHTH_OPHTH_EXAM:'OPHTH_OPHTH_EXAM',
OPHTH_OCU_EXAM:'OPHTH_OCU_EXAM',
OPHTH_EYEEXAMINATION:'OPHTH_EYEEXAMINATION',
OPHTH_LASER:'OPHTH_LASER',
OPHTH_OCT:'OPHTH_OCT',
OPHTH_FFA:'OPHTH_FFA',
OPHTH_INJECTION :'OPHTH_INJECTION',
OPHTH_CATARACT :'OPHTH_CATARACT',

//FootCare
FOOT_BIOTHESIOMETRIC:'FOOT_BIOTHESIOMETRIC',
FOOT_DOPPLER :'FOOT_DOPPLER',
FOOT_HIGHRISKFEET:'FOOT_HIGHRISKFEET',
FOOT_NEUROMETRICS:'FOOT_NEUROMETRICS',
FOOT_PERIPHERAL:'FOOT_PERIPHERAL',
FOOT_SENSITOMETER :'FOOT_SENSITOMETER',
FOOT_TCPO2:'FOOT_TCPO2',

//Cardiology
CARD_ECG:'CARD_ECG',
CARD_ECHO:'CARD_ECHO',
CARD_TREADMILL:'CARD_TREADMILL',

//Physiotherapy
PHYSIO_PHYSIOTHERAPYASSESSMENT : 'PHYSIO_PHYSIOTHERAPYASSESSMENT',

///Nutrition Therapy
DIET_NUTRITIONTHERAPY:'DIET_NUTRITIONTHERAPY',

//Education
EDU_HEALTHEDUCATION:'EDU_HEALTHEDUCATION',
//Urology
URO_UROLOGYEXAMINATION:'URO_UROLOGYEXAMINATION', 
//Vascular  
VASC_VASCULAREXAMINATION:'VASC_VASCULAREXAMINATION', 
//Nephrology 
NEPH_NEPHROLOGYEXAMINATION:'NEPH_NEPHROLOGYEXAMINATION',
//Neurology 
NEURO_NEUROLOGYEXAMINATION:'NEURO_NEUROLOGYEXAMINATION', 
//Orthopedics
ORTHO_ORTHOPEDICEXAMINATION:'ORTHO_ORTHOPEDICEXAMINATION',
//Dermatology 
DERMA_DERMATOLOGYEXAMINATION:'DERMA_DERMATOLOGYEXAMINATION',
//USG 
USG_ULTRASOUND:'USG_ULTRASOUND',     
//XRAY           
XRAY_XRAY:'Xray_X-RAY',      
//Gynaecology               
GYN_GYNAECOLOGYEXAMINATION:'GYN_GYNAECOLOGYEXAMINATION',

//Diet
DIET_RECOMMENDATION:'DIET_RECOMMENDATION',
DIET_ANALYSIS:'DIET_ANALYSIS',
DIET_CHART:'DIET_CHART',

//Reports = Individual Reports Roles

Patient_Data_Report :'PAT_DATA_RPT',
HealQ_Report :'HLQ_RPT',
Doctor_Wise_Register :'DR_WISE_REG',
Product_Sold_Vs_Current_Stock :'PROD_SOLD_VS_STOCK',
Medicine_Report_Date_Wise :'MED_RPT_DATEWISE',
Bed_Utilization :'BED_UTIL_RPT',
IP_Statics :'IP_STAT_RPT',
Bed_Transfer :'BED_TRNSFR_RPT',
Bed_Vacant_List :'BED_VACANT_RPT',
Bed_Occupancy :'BED_OCCUP_RPT',
IP_Advance_And_Charges_Report :'IP_ADV_CHG_RPT',
Supplier_Payment_Report :'SUP_PAY_RPT',
Receipt_Report :'RCPT_RPT',
Sales_Collection :'SALES_COLL_RPT',
Top_N_Report_By_Product :'TOPN_PROD',
Top_N_Report_By_Amount :'TOPN_AMT',
Batch_Wise_Product_Sold_Vs_Current_Stock :'BATCHWISE_SOLD_STOCK',
Pharmacy_Product_Sold_Vs_Current_Stock :'PROD_SOLD_STOCK',
Supplier_Wise_Medicine_Purchase_Report :'SUP_MED_PUR_RPT',
Medicine_Wise_Supplier_Purchase_Report :'MED_SUP_PUR_RPT',
Purchase_Analysis_Report :'PUR_ANALYSIS_RPT',
Product_Inward_Analysis_Report :'PROD_INWARD_ANALYSIS',
Sales_And_Sales_Return_HSN_Report :'SALES_RETURN_HSN',
Sales_HSN_Wise_Tax_Report_With_UQC :'SALES_HSN_TAX_UQC',
Sales_Margin_Day_Wise :'SALES_MARGIN_DAYWISE',
Sales_Margin_Product_Wise_Detailed :'SALES_MARGIN_PROD_DETAIL',
VAT_Report :'VAT_RPT',
Sales_Tax_Report :'SALES_TAX_RPT',
Purchase_Tax_Report :'PURCHASE_TAX_RPT',
Indent_Report :'INDENT_RPT',
Inter_Branch_Transfer_Summary_Report :'IB_TRANSFER_SUMMARY',
Branch_Requisition_Status_Report :'BR_REQ_STATUS',
Branch_Dispatch_Status_Report :'BR_DISP_STATUS',
Stock_Valuation_Report :'STOCK_VAL_RPT',
Warehouse_Wise_Stock_Report :'WH_STOCK_RPT',
Product_Analysis :'PROD_ANALYSIS_RPT',
Overall_Medicine_Inventory_Deficit :'MED_INV_DEFICIT',
Expiry_Report_Distributorwise :'EXPIRY_DIST_RPT',
Non_Moving_Medicines :'NON_MOV_MED',
Excess_Stock_Supplier_Wise :'EXCESS_SUP_STOCK',
Purchase_Report :'PURCHASE_RPT',
Stock_Status_Report :'STOCK_STATUS_RPT',
Indent_Item_Request_Report :'INDENT_ITEM_REQ',
Indent_Transfer_Report :'INDENT_TRANSFER_RPT',
Item_Not_Transfer_Report :'ITEM_NOT_TRANSFER',
Item_Less_Report:'ITEM_LESS_RPT',
Lab_Collection_By_Date :'LAB_COLL_DATE',
Lab_Collection_By_Service :'LAB_COLL_SERVICE',
Lab_Revenue_Collection :'LAB_REVENUE_RPT',
Service_Report_With_Performing_Doctors :'SERVICE_PERF_DOC',
OP_Service_Wise_GST_Report :'OP_SVC_GST_RPT',
OP_VAT_Report :'OP_VAT_RPT',
IP_UnBilled_And_Billed_Service_Report :'IP_UNBILL_BILL_RPT',
Discharge_Report :'DISCHARGE_RPT',
Advance_Balance_Report_Not_Discharged :'ADV_BAL_NOTDISC',
IP_Room_Wise_Collection_Report :'IP_ROOM_COLL_RPT',
IP_Service_Wise_Report :'IP_SVC_RPT',
IP_Service_Wise_GST_Report :'IP_SVC_GST_RPT',
IP_VAT_Report :'IP_VAT_RPT',
IP_OP_Overall_Summary_Report :'IP_OP_SUMMARY',
Pharmacy_Overall_Summary_Report :'PHARM_SUMMARY',
HMS_Payment_Overall_Summary_Report :'HMS_PAY_SUMMARY',
Pharmacy_Payment_Overall_Summary_Report :'PHARM_PAY_SUMMARY',
Bill_Wise_Concession_Report :'BILL_CONCESSION_RPT',
Department_Revenue_List_IP_OP :'DEPT_REV_LIST',
Radiology_Summary_Report :'RADIOLOGY_SUMMARY',
OT_Booking_List :'OT_BOOKING_LIST',
OT_Detailed_Surgery_Report :'OT_DETAILED_SURGERY',
OT_Booking_Cancel_List :'OT_BOOKING_CANCEL',
OT_Operation_List :'OT_OPERATION_LIST',
Consolidated_Surgery_Report :'CONSOLIDATED_SURGERY',
CEA_Lab_Register :'CEA_LAB_REGISTER',
CEA_Imaging_Register :'CEA_IMG_REGISTER',
CEA_Admission_Discharge :'CEA_ADM_DISCHARGE',
CEA_Patients_Register :'CEA_PAT_REGISTER',
Doctor_Notes :'DOC_NOTES',
Nurse_Notes :'NURSE_NOTES',
Instructions :'INSTR_NOTES',
Therapy_Notes :'THERAPY_NOTES',
Vital_Charts :'VITAL_CHARTS',
Prescription_Report :'PRESC_RPT',
Psychology_Report :'PSYCHOLOGY_RPT',
User_Wise_Performance_Report :'USER_WISE_PERF_RPT',
Opthomology_PrepostOT_Report:'OPHTH_PRE_POST_OT_RPT',

Common_Reports :'COMMON_RPTS',
User_Reports :'USER_RPTS',
Registration_Reports :'REG_RPTS',
Zatca_Reports :'ZATCA_RPTS',
MedicineReport_PatientWise:'MED_RPT_PATIENT_WISE',
PatientLog_Management_System:'PAT_LOG_MGMT_SYS',

//INdividual Assests

AssetPurchase: 'ASSET_PURCHASE',
AssetPurchaseReturn: 'ASSET_PURCHASE_RET',
AssetSales: 'ASSET_SALES',
AssetStock: 'ASSET_STOCK',
AssetOpeningStock: 'ASSEST_OPEN_STOCK',
AssetInternalDepartment: 'ASSET_INTERNAL_DEPT',
AssetWarehousewiseStock: 'ASSET_WAREHOUSE',

//INdividual Masters

APP_MANAGER:'APP_MANAGER',
BRANCH_BASED_MST:'BRANCH_BASED_MST',
TENANT_BASED_MST:'TENANT_BASED_MST',
COMMON_TYPE_MST:'COMMON_TYPE_MST',
COMMON_SUBTYPE_MST:'COMMON_SUBTYPE_MST',
APPROVAL_PAGE_LVL:'APPROVAL_PAGE_LVL',
HOSPITAL_SLOTS:'HOSPITAL_SLOTS',
PACKAGE_TYPE:'PACKAGE_TYPE',
PACKAGE_VALIDITY:'PACKAGE_VALIDITY',
HMS_LOCATION:'HMS_LOCATION',
VEHICLE:'VEHICLE',
CARRIER:'CARRIER',
DSM_HEADER:'DSM_HEADER',
DSM_SUB_HEADER:'DSM_SUB_HEADER',
DSM_QUESTION:'DSM_QUESTION',
FOOD_MASTER:'FOOD_MASTER',
DIET_TIME_SLOT:'DIET_TIME_SLOT',
SMS_USAGE_TRACKING:"SMS_USAGE_TRACKING",
WHATSAPP_USAGE_TRACKING:"WHATSAPP_USAGE_TRACKING",
EMAIL_USAGE_TRACKING:"EMAIL_USAGE_TRACKING",

UID_GEN: "UID_GEN",
MAND_SET: "MAND_SET",
CASE_TEMP: "CASE_TEMP",
MED_GST: "MED_GST",
MED_PRICE_DROP: "MED_PRICE_DROP",
FILE_UPLOAD: "FILE_UPLOAD",
GRACE_CHG_SETUP: "GRACE_CHG_SETUP",
MANUAL_DATE_PICKER: "MANUAL_DATE_PICKER",
OFFICIAL_HOLIDAY: "OFFICIAL_HOLIDAY",
SCHEME_TYPE: "SCHEME_TYPE",

OVERALL_PRINT:"PG_EHR_Overall_Summary",
PREGNANCY_SCREENING:"PG_Pregnancy_Screening",
CL_CATH_LAB:"CL_CATH_LAB",
BO_BILLING_OFFICE:"BO_BILLING_OFFICE",
MRTY_MORTUARY:"MRTY_MORTUARY",

//Master-menu
MASTER_MENU:"PG_MASTER_DASHBOARD",

//Triage (device-driven vitals capture) / Device Integration
TRIAGEDEVICECAPTURE:"PG_TRIAGE_DEVICE_CAPTURE",
DEVICEINTEGRATION:"PG_DEVICE_INTEGRATION",
// Asha
REFERRAL_WORKER_MASTER: "PG_REFERRAL_WORKER_MASTER",
REFERRAL_WORKER_COMMISSION:"PG_REFERRAL_WORKER_COMMISSION",
REFERRAL_WORKER_COMMISSION_PAYMENT: "PG_REFERRAL_WORKER_COMMISSION_PAYMENT",
REFERRAL_WORKER_COMMISSION_APPROVAL: "PG_REFERRAL_WORKER_COMMISSION_APPROVAL",
REFERRAL_WORKER_COMMISSION_DRAFT: "PG_REFERRAL_WORKER_COMMISSION_DRAFT"


},
task:{
CL_CATH_LAB:"TSK924001",
MRTY_MORTUARY:"TSK925001",
BO_BILLING_OFFICE:"TSK926001",

GPSERVICE:"TSK011004",
NEWREG:"TSK002001",
ABHAREG:'TSK800001',
ABHAPHY:"TSK800002",
ABHABRANCH:"TSK800003",
ABHAMEDMST:"TSK800004",
ABHAPRES : "TSK800005",
ABHAAPPOINTMENT:"TSK800006",
ABHAOTBOOK :"TSK800007",
ABHAUNITMST:"TSK800008",
ABHADEPT:"TSK800009",
ABHATREATMENTPLAN:"TSK800011",
ABHASURGERYMST:"TSK800010",
ABHAALLERGY:"TSK800013",

ABHASERVICEMST:"TSK800014",
ABHAEHRDASHBOARD:"TSK800012",
ABHASOCIALHABITS:"TSK800015",
ABHADIAGNOSISMST:"TSK800016",
ABHAVACCINE:"TSK800017",
ABHALAB:"TSK800018",
DECEASEDREG:"TSK002004",
TASKORDERCOUNSELLING:"TSK904004",
ABHACHIEFCOMPMST:"TSK800019",
ABHAIPBilling:"TSK800020",
ABHAOPBilling:"TSK800021",
ABHAPharmacy:"TSK800022",
ABHADischargeSummary:"TSK800023",
ABHARadiology:"TSK800024",



//New Task Access Declare By RAJA 11-11-21
MEDICALTOURISM:"TSK002003",
REGATTACH:"TSK002002",
OPBILLTRNS:"TSK200001",
RECEIPTRNS:"TSK200002",
PENDINGBILLLIST:"TSK200003",
ACCPAYMT:"TSK202001",
SUPPAYMT:"TSK202002", 
EHRCHIEFCOMPMST:"TSK100001",
EHRMEDICALHISTORYMST:"TSK100002",
EHRSOCIALHABITSMST:"TSK100003", 
EHREXAMMST:"TSK101001",
EHRINSTRUCTIONSMST:"TSK101002",
EHRDIETPLANMST:"TSK101003",
EHRTRAININGCLASSMST:"TSK101004",
EHRTREATPLANMST:"TSK101005", 
EHRDASHBOARD:"TSK100051",
EHRMEDICALHISTORYTRANS:"TSK100052",
EHROPCASESHEET:"TSK100053",
EHROPADVCASESHEET:"TSK101051",
THERAPYTRANS:"TSK102001",

RPTOPBILLCOLLECTIONDAILY:"TSK200051",
RPTOPBILLCOLLECTIONSRVCCATEGORY:"TSK200052",
RPTBILLCOLLECTIONSRVCCATEGORY:"TSK200053",
RPTOPCOLLECTION:"TSK200054",
RPTDOCTORREVENUE:"TSK200055",
RPTDEPARTMENTREVENUE:"TSK200056",
RPTOPRECEIPTSUMMARY:"TSK200057",
RPTSERVICECATEGORY:"TSK200058",
RPTMEDICALHISTORY:"TSK100201",
RPTREFERRAL:"TSK100202",
RPTWARD:"TSK100203",
RPTBED:"TSK100204",
RPTBUILDING:"TSK100205",
RPTROOM:"TSK100206",
RPTFLOOR:"TSK100207",
RPTNURSINGCOUNTER:"TSK100208",
IPRPTCOLLECTION:"TSK201051",
IPRPTADVANCESUMMARY:"TSK201052",
COMMUNICATION:"TSK106001",

TEMPLATEMST:"TSK105001",
TMPLCERTIFICATEMST:"TSK105021",
TMPLCONSENTMST:"TSK105022",
TMPLDAYCARESUMMMST:"TSK105023",
//End Task Access Declare By RAJA 16-11-21
// Abirami P declration
PHYMST:'TSK003001',
PHYCONFMST:'TSK003002',
PHAPPLIST:"TSK003003",
PHSCHDULEMST:"TSK003004",
PHAPPBOOK:"TSK003005",
PHAPPQUEUELIST:"TSK003006",
PGLAUNMST:"TSK103001",
PGLAUNISSUED:"TSK103021",
PGPACKAGEMST:"TSK300001",
PGPACKAGEMODULEMST:"TSK300002",
PGTASKMST:"TSK300003",
PGTASKACTIONMST:"TSK300004",
PGMODULEMST:"TSK300005",
PGPAGEEMST:"TSK300006",
PGSUBSCRIBTIONTRANS:"TSK300007",
PGUSERTRANS:"TSK300008",
PGROLETRANS:"TSK300010",
PGBRANCHLIST:"TSK300011",
PGBRANCHTRANS:"TSK300012",
PGADMINDASHBOARD:"TSK300013",
PGTENANTTRANS:"TSK300014",
PGMEDMST:"TSK001050",
PGPHARMMST:"TSK006002",
PGSTORAGEMST:"TSK006003",
PGSTOREMST:"TSK006004",
PGSUPLRMST:"TSK006005",
PGCUSTOMERMST:"TSK001001",
PGDEPARTMENTMST:"TSK001002",
PGDESIGNINGMST:"TSK001003",
PGEXPANSEMST:"TSK001004",
PGHOSPCONFMST:"TSK001005",
PGCLIINSTRUCTIONSMST:"TSK001006",
PGPAYARMST:"TSK001007",
PGPRNCONFMST:"TSK001008",
PGREFMST:"TSK001009",
PGSERVDETMST:"TSK001010",
PGSRVCMST:"TSK001021",
PGSRVCCATMST:"TSK001022",
PGSRVCSUBCATMST:"TSK001023",
PGSHIFTMST:"TSK001024",
PGBANKMST:"TSK001025",
PGCOUNTRYMST:"TSK001026",
PGCREDITNOTEREASON:"TSK001027",
PGDIAGNOSISMST:"TSK001028",
PGDISTRICTMST:"TSK001029",
PGLEAVEMST:"TSK001030",
PGMEDICINEGENERICSMST:"TSK001031",
PGHIGHRISKMST:"TSK001032",
PGINSTITUTIONMST:"TSK001033",
PGLANGUAGEMST:"TSK001036",
PGMEDICINEMANUFACTURERMST:"TSK001037",
PGMEDICINECATEGORYMST:"TSK001038",
PGPURCHASERETURNREASONMST:"TSK001039",
PGQUALIFICATIONMST:"TSK001040",
PGSALESRETURNREASONMST:"TSK001041",
PGUPIPAYMENTMODEMST:"TSK001044",
PGVACCINEMST:"TSK008001",
PGVACINEAGEDESCMST:"TSK008002",
PGVACCINEBRANDMST:"TSK008003",
PGVACCINESETTINGSMST:"TSK008004",
PGPEADIATRCCASESHEETTRANS:"TSK008021",
PGVIDEOCONSULTRANS:"TSK010001",
PGRECORDINGTRANS:"TSK010002",
PGJOBCATEGORYMST:"TSK001035",
STATEMST:"TSK001042",
COUNCILMST:"TSK001045",
ADMTYPE:"TSK004001",
BEDMST:"TSK004002",
BUILDINGMASTER:"TSK004003",
NURSINGCOUNTER:"TSK004004",
ROOMMASTER:"TSK004005",
WARDMASTER:"TSK004006",
FLOORMASTER:"TSK004009",
DEFAULTWARDBASEDSRVC:"TSK004010",
BEDVIEW:"TSK004022",
DIETPLAN:"TSK004007",
DISREASON:"TSK004008",
ADMMST:"TSK004021",
OBSDASHBOARD:"TSK009021",
MENHISTORY:"TSK009001",
HIGHRISK:"TSK009002",
TRAININGCLASS:"TSK009003",
BOOKLET:"TSK009004", 
EMPLOEEMST:'TSK001048',
PGMEDMSTGSTUPDATE:'TSK006044',


PGINDENTREQUEST:"TSK006035",
PGINDENTAPPROVAL:"TSK006036",
PGIDENTISSUE:"TSK006037",
PGINDENTRECEIVE:"TSK006038",
PGPURCHASEORDER:"TSK006039",
PGPURCHASEORDERAPPROVAL:"TSK006040",

//Pharmacy - Implemented by Thenmozhi
PURCHASE : "TSK006021",
PURCHASERETURN : "TSK006022",
SALESDASHBOARD : "TSK006023",
SALES : "TSK006024",
SALESRETURN : "TSK006025",
STOCKLIST : "TSK006026",
EXPIRYLIST: "TSK006027",
LOWSTOCKLIST: "TSK006028",
EXCESSSTOCKLIST: "TSK006029",
OPENINGSTOCK: "TSK006030",
PHARMACYCREDITBILL : "TSK006031",
PHARMACYRECEIPT : "TSK006032",
SUPPLIERDUES : "TSK006033",
PHARMACYSUPPLIERPAYMENT : "TSK006034",
OPENSTOCKFILEUPLOAD:'TSK006043',
OLDPURCHASE:'TSK006045',
PG_PH_PUR_ORDER_APPROVAL:'TSK006226',

//Dental - Thenmozhi
DENTALPROBLEM : "TSK007001",
DENTALPROCEDURES: "TSK007002",
DENTALCASESHEET : "TSK007021",

//Pharmacy Reports
PURCHASEREPORT:"TSK006201",
PURCHASERETRUNREPORT:"TSK006202",
SALESREPORT:"TSK006203",
SALESRETURNREPORT:"TSK006204",
CONSOLIDATEDSALES:"TSK006205",
CONSOLIDATEDPURCHASE:"TSK006206",
CLOSINGSTOCKREPORT:"TSK006207",
STOCKUPDATEHISTORY:"TSK006208",
PRODUCTWISESALESREPORT:"TSK006209",
SCHEDULEHREPORT:"TSK006210",
PURCHASEABSTRACT:"TSK006211",
STOCKTRANSACTIONREPORT:"TSK006212",

//Anupama
WARDFACILITIESMST: "TSK001046",
MEDICALCERTIFICATE: "TSK105001",

//Abirami
BEDTRANS:"TSK004027",
DISADV:"TSK004028",
DISENTRY:"TSK004029",
DISSUM:"TSK004030",
IPVITAL:"TSK004031",
IPNURSENOTES:"TSK004021",
IPINTAKEOUTPUT:"TSK004033",
IPDOCTORNOTES:"TSK004034",
IPPRES:"TSK004035",
IPMEDINTAKE:"TSK004025",
ASSETTYPE:"TSK104002",
ASSETMST:"TSK104001",
LABCAT:"TSK005001",
LABGRP:"TSK005002",
LABPKG:"TSK005003",
LABTST:"TSK005004",
LABMAT:"TSK005005",
LABMET:"TSK005006",
LABQUEUE:"TSK005007",
LABORDERLIST:"TSK005008",
LABRESULTENTRY:"TSK005009",
RADQUEUE:"TSK107001",
RADLIST:"TSK107002",
ADVPAY:"TSK201001",
IPBILL:"TSK201002",
IPBILLSERVICES:"TSK201003",
ROOMRENT:"TSK201004",
USERTYPEMST : "TSK001049",
UNITMST : "TSK100004",
REPORTMENU:"TSK400001",

//CEA Report
ADMSNDISCREG:"TSK004060",
IMAGINGREG:"TSK107020",
LABREG:"TSK005020",
PATIENTREG:"TSK002020",

//Inventory - Task
ITEMCATEGORY:"TSK111001",
ITEMMANUFACTURER:"TSK111002",
ITEMLOCATION:"TSK111003",
ITEMTYPE:"TSK111004",
ITEMMST:"TSK111005",

//patient list 
CLINICALDASH:"TSK004069",
DEATHREG:"TSK101061",


//OT -Master
OTCOUNTMST:"TSK108001",
OTCHECKLISTMST:"TSK108002",
OTIMPLANTSMST:"TSK108003",
OTSURGERYMST:"TSK108004",
OTTABLEMST:"TSK108005",
CSSDITEMMST:"TSK108006",

//Asset
ASSETSUBTYPE:"TSK104003",

// OT Transactions by Abirami P
OTBOOKMST:"TSK108051",
OTSCHEDULEMST:"TSK108052",
OTNOTESMST:"TSK108053",
OTREPORTSMST:"TSK108055",

// Marketing Leads by RAJA
MARKTLEADS:"TSK600001",
//IP - DischargeList
DISCHARGELIST:"TSK004037",
//Santhiya
PATREFERRALLIST:"TSK202004",
REVENUESHARELIST:"TSK202003",
REVENUESHARECONFIG:"TSK001050",

// patient-wallet by Abirami.P
PGPATWALLETTRANS:"TSK202007",
PGWALLETTRANSLIST:"TSK202008",

PGCOMBINEDVACCINE:"TSK001052",

// op hold bill
PGOPHOLDBILL:"TSK200004",
COMVACCMAD:"TSK001051",

//Visit Mode Mst Declare By Thenmozhi 29-01-2022
VISITMODEMST:"TSK001053",

PGBANKTRANS:"TSK202009",

// Lab Reports: 
PGTATREPORT:"TSK005011",
PGSTAREPORT:"TSK005012",
PGDOCINVREVREPORT:"TSK005013",

//Accounts Reports
CANCELADVLIST:"TSK202010",
CREDITBILLSELF:"TSK202011",
RECEIPTLISTSELF:"TSK202012",
CANCELLEDBILLLISTBOTHOPIPPAGE:"TSK202013",
//Analytics-Thenmozhi
ANALYTICS:"TSK400002",
//Lab Reports
PG_EDIT_LOG_REPORT:"TSK005015",
PG_INHOUSE_OUTSOURCE_REPORT:"TSK005014",
PGLABREVCOLLECTIONREPORT:"TSK005016",
PGLABCOLLECTIONBYDATE:"TSK005017",
PGLABCOLLECTIONBYSERVICE:"TSK005018",
// IP hold bill:-
PGIPHOLDBILL:"TSK201005",

// SMS related page:-
PGCONTENTMGMTLIST:"TSK001054",
PGSMSCREDITPAGE:"TSK001055",
PGTEMPLATEPURCHASEPAGE:"TSK001056",
PGGATEWAYCONFIGURATIONPAGE:"TSK001057",

// Collection Reports IP:-
PGIPBILLCANCELLEDREPORT:"TSK201053",
PGIPADVANCECANCELLEDSUMMARYREPORT:"TSK201054",
PGIPCOLLECTIONSERVICEWISEREPORT:"TSK201055",
PGIPSERVICECATEGORYREPORT:"TSK201056",

// Collection Reports OP:-
PGOPBILLCANCELLEDREPORT:"TSK200059",
PGOPSERVICEWISEREPORT:"TSK200060",
// Walkin Module (Direct Patient Billing):-
WALKINPATIENTREGISTRATIONPAGE:"TSK020001",
WALKINPATIENTBILLINGPAGE:"TSK020002",
WALKINPATIENTCANCELLEDBILLLISTPAGE:"TSK020003",

//Lab Barcode Template
PGBARCODETEMPLATE:"TSK005019",
//Lab Equipment Machine
PGLEM:"TSK005010",
//UnBilled Service&Service Category
PGIPUNBILLEDSERVICEREPORT:"TSK201057",
PGIPUNBILLEDSERVICECATEGORYREPORT:"TSK201058",

//Lab statistic count report
LAB_STATISTIC_COUNT : "TSK005021" , 
//Lab Report (Lab Patient Package Report)
LAB_PACKAGE_PATIENT_DETAILS : "TSK005022",

//IP Statistic Report - Santhiya
CONSOLIPREPORTDEPT: "TSK004038",
MONTHCONSOLIPREPORTDEPT:"TSK004039",
CONSOLIPREPORTWARD:"TSK004040",
MONTHCONSOLIPREPORTWARD:"TSK004041",
CONSOLIPREPORTPHY:"TSK004042",
MONTHCONSOLIPREPORTPHY:"TSK004043",
CONSOLIPREPORTADMTYPE:"TSK004044",
MONTHCONSOLIPREPORTADMTYPE:"TSK004045",

DOC_STATISTICS:"TSK003007",

//Daybook
DayBookCon:"TSK202014",
DayBookDet:"TSK202015",

//Overall collection Summary
OverallCollSumCon:"TSK202016",
OverallCollSumDet:"TSK202017",
//Accounts Group Master
ACCOUNTSGROUPMST:"TSK202018",

//Others Income:-
OTHERINCOMELIST:"TSK202019",
//EHR Report:-
EHRREPORT:"TSK101006",

// Inventory module:-
PGITEMSALESMST:"TSK111025",
PGITEMINDENTREQUEST:"TSK111020",
PGITEMINDENTAPPROVAL:"TSK111026",

PGWAREHOUSEMST:"TSK111006",
PGQCREASONMST:"TSK111007",
PGSCRAPREASONMST:"TSK111008",
PGCREDITNOTEREASONMST:"TSK111009",
PGINTDEPTMST:"TSK111010",
PGDEBITNOTEREASONMST:"TSK111011",

CAMPMASTER:"TSK501001",
CAMPPATIENTLIST:"TSK501002",

//OPD Setup by Raja 2022-11-09 :)
OPDSEQUENCEGENERATOR:"TSK021001",
OPDMONITORSETUP:"TSK021002",
INVENTORYPURCHASE:"TSK111012",
INVENTORYPURCHASERETURN:"TSK111013",
INVENTORYPURCHASEORDER:"TSK111014",
ITEMSCRAPENTRY:"TSK111015",
ITEMOPENINGSTOCK:"TSK111017",
CREDITNOTEENTRY:"TSK111022",
DEBITNOTEENTRY:"TSK111023",
ITEMSTOCKLIST:"TSK111016",
INTERNALDEPTSTOCK:"TSK111018",
SUPLIERDASHBOARD:"TSK111024",
INVENTORYSUPPLIERDUES:"TSK111021",
WAREHOUSEREPORT:"TSK111019",

//IP-Patient-Monitoring, by Anandaraj
PATIENTMONITORING:"TSK004046",

//Patient Package Module TaskID

PATIENTPACKAGE:"TSK011001",

//Upcoming-visit-report, by Ajai
UPCOMING_VISIT_REPORT:"TSK011002",

//Consolidated-patient-package-list,by Mageshwaran
PATIENT_PACKAGE:"TSK011001",
//Detailed-patient-package-list,by Mageshwaran
PACKAGE_REPORT:"TSK011003",


SALES_COLLECTION_REPORT:"TSK006216",
DET_SALES_PROFIT_LOSS_REPORT:"TSK006218",
SALES_SOLDOUT_REPORT:"TSK006219",
DET_STOCK_REPORT:"TSK006220",
COUNTER_WISE_STOCK_REPORT:"TSK006221",
Stock_VAL_REPORT:"TSK006214",
PUR_TAX_REPORT:"TSK006215",


//Blood Bank Module TaskID
BLOODDASHBOARD:"TSK012001",
BLOODDONOR:"TSK012002",
BLOODCOLLECTION:"TSK012003",
BLOODREQUEST:"TSK012004",
BLOODSTOCKLIST:"TSK012005",
BLOODOPENINGSTOCK:"TSK012006",
BLOODDISCARD:"TSK012007",
BLOODRETURN:"TSK012008",
BLOODTRANSFUSION:"TSK012009",

//CRM Module TaskID
ENQUIRYSTATUSMASTER:"TSK013001",
ENQUIRYMASTER:"TSK013002",
SALESQUOTE:"TSK013003",
SALESINVOICE:"TSK013004",
CRMRECEIPT:"TSK013005",

//Pharmacy Credit Note - by Anandaraj M
PHCREDITNOTE:"TSK006041",
//Pharmacy Purchase Return Adjustment - by Anandaraj M
PHPURETURNADJT:"TSK006042",

//Payer
PAYERDASHBOARD:"TSK014001",

//Lab Queue Page
LABQUEUE_NEW:"TSK005023",
LABQUEUE_SAMPLE:"TSK005024",
LABQUEUE_RESULTENTRY:"TSK005025",
LABQUEUE_APPROVAL:"TSK005026",
LABQUEUE_COMPLETED:"TSK005027",
Lab_Result_Edit: "TSK005030",


//Assessment - By Mageshwaran
ASSESSMENTTEMPLATEGENERATOR:"TSK101008",
IPASSESSMENTTEMPLATETRANSACTION:"TSK101009",
OPASSESSMENTTEMPLATETRANSACTION:"TSK101011",
SCORINGTABLE:"TSK101010",
NURSEHANDOVER:"TSK004061",

//VOPD
USERDASHBOARD:'TSK900001',
PATIENTQUEUE :'TSK900002',
TRIAGEQUEUE :'TSK900003',
LABQUEUEVOPD :'TSK900004',
RADIOLOGYQUEUE :'TSK900005',
PHARMACYQUEUE :'TSK900006',
PHYSICIANQUEUE :'TSK900007',

REFREPORT:'TSK400003',
APPTREMAINDER:'TSK003008',
IPREPORT:'TSK400004',

//Back dated order
LAB_BACKDATED_ORDER:'TSK005028',

//Emergency
EMERGENCYDASHBOARD:'TSK901001',

LABRESAMPLELIST : 'TSK005029',

//Backdated
BACKDATEDREGISTRATION: 'TSK002005',
BACKDATEDADMISSION:'TSK004062',

//Asset By Magesh
ASSETREGISTER:'TSK104004', 
AMCRENEWAL:'TSK104005',
RENTALRENEWAL:'TSK104006',

//Approval
APPROVALOPBill:'TSK902004',
APPROVALQUEUELIST:'TSK902001',
REGISTRATION:'TSK902002',
ADMISSION: 'TSK902003',
COMPLETEDAPPROVAL: 'TSK902005',
REJECTEDAPPROVAL: 'TSK902006',

//Health Card/ Loyalty/ Referral Bonus
HEALTHCARDMST: 'TSK903001',
LOYALTYDISCMST: 'TSK903002',
REFERRALDISCMST: 'TSK903003',

ACTIVECARDDET: 'TSK903004',
INACTIVECARDDET: 'TSK903005',
CARDLOGDET: 'TSK903006',

HEALTHCARDINOPBILL: 'TSK903007',
LOYALTYDISCINOPBILL: 'TSK903008',
REFERRALDISCINOPBILL: 'TSK903009',

PATIENTINDENTMONITORING:'TSK904001',
PATIENTCAREENTRY:'TSK904002',
TASKORDER:'TSK904003',
 
NURSEINDENT:'TSK004063',

//MV CaseSheets
//Dental
DENTAL_EXAMINATION:'TSK007022',

//Podiatry
POD_WOUNDCARE:'TSK907001',

//Psychology
PSY_PSYCHOLOGYEXAMINATION  :'TSK911001',

//Ophthalmology
IP_OPHTH_EYE_PREOT:'TSK906011',
OP_OPHTH_EYE_PREOT:'TSK906012',
IP_OPHTH_EYE_POSTOT:'TSK906013',
OP_OPHTH_EYE_POSTOT:'TSK906014',
OP_OPHTH_EYE_IOL:'TSK906015',
IP_OPHTH_EYE_IOL:'TSK906016',
IP_OPHTH_EYE_POSTFOLLOWUP:'TSK906017',
OP_OPHTH_EYE_POSTFOLLOWUP:'TSK906018',
OPHTH_SPEC:'TSK906009',
OPHTH_REFRACTION:'TSK906010',
OPHTH_OPHTH_EXAM:'TSK906007',
OPHTH_OCU_EXAM:'TSK906008',
OPHTH_EYEEXAMINATION:'TSK906001',
OPHTH_LASER:'TSK906002',
OPHTH_OCT:'TSK906003',
OPHTH_FFA:'TSK906004',
OPHTH_INJECTION :'TSK906005',
OPHTH_CATARACT :'TSK906006',

//FootCare
FOOT_BIOTHESIOMETRIC:'TSK908001',
FOOT_DOPPLER :'TSK908002',
FOOT_HIGHRISKFEET:'TSK908004',
FOOT_NEUROMETRICS:'TSK908003',
FOOT_PERIPHERAL:'TSK908005',
FOOT_SENSITOMETER :'TSK908006',
FOOT_TCPO2:'TSK908007',

//Cardiology
CARD_ECG:'TSK909001',
CARD_ECHO:'TSK909002',
CARD_TREADMILL:'TSK909003',

//Physiotherapy
PHYSIO_PHYSIOTHERAPYASSESSMENT : 'TSK920001',

///Nutrition Therapy
DIET_NUTRITIONTHERAPY:'TSK910004',

//Education
EDU_HEALTHEDUCATION:'TSK921001',
//Urology
URO_UROLOGYEXAMINATION:'TSK914001', 
//Vascular  
VASC_VASCULAREXAMINATION:'TSK915001', 
//Nephrology 
NEPH_NEPHROLOGYEXAMINATION:'TSK916001',
//Neurology 
NEURO_NEUROLOGYEXAMINATION:'TSK917001', 
//Orthopedics
ORTHO_ORTHOPEDICEXAMINATION:'TSK918001',
//Dermatology 
DERMA_DERMATOLOGYEXAMINATION:'TSK919001',
//USG 
USG_ULTRASOUND:'TSK922001',     
//XRAY           
XRAY_XRAY:'TSK923001',      
//Gynaecology               
GYN_GYNAECOLOGYEXAMINATION:'TSK912001',

//Diet
DIET_RECOMMENDATION:'TSK910001',
DIET_ANALYSIS:'TSK910002',
DIET_CHART:'TSK910003',

//reports roles for individual reports

PAT_DATA_RPT :'TSK400008',
HLQ_RPT :'TSK400009',
DR_WISE_REG :'TSK400010',
PROD_SOLD_VS_STOCK :'TSK400011',
MED_RPT_DATEWISE :'TSK400012',
BED_UTIL_RPT :'TSK400013',
IP_STAT_RPT :'TSK400014',
BED_TRNSFR_RPT :'TSK400015',
BED_VACANT_RPT :'TSK400016',
BED_OCCUP_RPT :'TSK400017',
IP_ADV_CHG_RPT :'TSK400018',
SUP_PAY_RPT :'TSK400019',
RCPT_RPT :'TSK400020',
SALES_COLL_RPT :'TSK400021',
TOPN_PROD :'TSK400022',
TOPN_AMT :'TSK400023',
BATCHWISE_SOLD_STOCK :'TSK400024',
PROD_SOLD_STOCK :'TSK400025',
SUP_MED_PUR_RPT :'TSK400026',
MED_SUP_PUR_RPT :'TSK400027',
PUR_ANALYSIS_RPT :'TSK400028',
PROD_INWARD_ANALYSIS :'TSK400029',
SALES_RETURN_HSN :'TSK400030',
SALES_HSN_TAX_UQC :'TSK400031',
SALES_MARGIN_DAYWISE :'TSK400032',
SALES_MARGIN_PROD_DETAIL :'TSK400033',
VAT_RPT :'TSK400034',
SALES_TAX_RPT :'TSK400035',
PURCHASE_TAX_RPT :'TSK400036',
INDENT_RPT :'TSK400037',
IB_TRANSFER_SUMMARY :'TSK400038',
BR_REQ_STATUS :'TSK400039',
BR_DISP_STATUS :'TSK400040',
STOCK_VAL_RPT :'TSK400041',
WH_STOCK_RPT :'TSK400042',
PROD_ANALYSIS_RPT :'TSK400043',
MED_INV_DEFICIT :'TSK400044',
EXPIRY_DIST_RPT :'TSK400045',
NON_MOV_MED :'TSK400046',
EXCESS_SUP_STOCK :'TSK400047',
PURCHASE_RPT :'TSK400048',
STOCK_STATUS_RPT :'TSK400049',
INDENT_ITEM_REQ :'TSK400050',
INDENT_TRANSFER_RPT :'TSK400051',
ITEM_NOT_TRANSFER :'TSK400052',
LAB_COLL_DATE :'TSK400053',
LAB_COLL_SERVICE :'TSK400054',
LAB_REVENUE_RPT :'TSK400055',
SERVICE_PERF_DOC :'TSK400056',
OP_SVC_GST_RPT :'TSK400057',
OP_VAT_RPT :'TSK400058',
IP_UNBILL_BILL_RPT :'TSK400059',
DISCHARGE_RPT :'TSK400060',
ADV_BAL_NOTDISC :'TSK400061',
IP_ROOM_COLL_RPT :'TSK400062',
IP_SVC_RPT :'TSK400063',
IP_SVC_GST_RPT :'TSK400064',
IP_VAT_RPT :'TSK400065',
IP_OP_SUMMARY :'TSK400066',
PHARM_SUMMARY :'TSK400067',
HMS_PAY_SUMMARY :'TSK400068',
PHARM_PAY_SUMMARY :'TSK400069',
BILL_CONCESSION_RPT :'TSK400070',
DEPT_REV_LIST :'TSK400071',
RADIOLOGY_SUMMARY :'TSK400072',
OT_BOOKING_LIST :'TSK400073',
OT_DETAILED_SURGERY :'TSK400074',
OT_BOOKING_CANCEL :'TSK400075',
OT_OPERATION_LIST :'TSK400076',
CONSOLIDATED_SURGERY :'TSK400077',
CEA_LAB_REGISTER :'TSK400078',
CEA_IMG_REGISTER :'TSK400079',
CEA_ADM_DISCHARGE :'TSK400080',
CEA_PAT_REGISTER :'TSK400081',
DOC_NOTES :'TSK400082',
NURSE_NOTES :'TSK400083',
INSTR_NOTES :'TSK400084',
THERAPY_NOTES :'TSK400085',
VITAL_CHARTS :'TSK400086',
PRESC_RPT :'TSK400087',
PSYCHOLOGY_RPT :'TSK400088',
USER_WISE_PERF_RPT :'TSK400096',
OPHTH_PRE_POST_OT_RPT :'TSK400097',
COMMON_RPTS :'TSK400089',
USER_RPTS :'TSK400090',
REG_RPTS :'TSK400091',
ZATCA_RPTS :'TSK400092',
PHILHEALTH_RPTS :'TSK400098',
MED_RPT_PATIENT_WISE:'TSK400093',
PAT_LOG_MGMT_SYS:'TSK400094',
ITEM_LESS_RPT:'TSK400095',

//indivudual Assets
AssetPurchase: 'TSK104007',
AssetPurchaseReturn: 'TSK104008',
AssetSales: 'TSK104009',
AssetStock: 'TSK104010',
AssetOpeningStock: 'TSK104011',
AssetInternalDepartment: 'TSK104012',
AssetWarehousewiseStock: 'TSK104013',

//Individual Masters

APP_MANAGER:"TSK001060",
BRANCH_BASED_MST:"TSK001061",
TENANT_BASED_MST:"TSK001062",
COMMON_TYPE_MST:"TSK001063",
COMMON_SUBTYPE_MST:"TSK001064",
APPROVAL_PAGE_LVL:"TSK001065",
HOSPITAL_SLOTS:"TSK001066",
PACKAGE_TYPE:"TSK001067",
PACKAGE_VALIDITY:"TSK001068",
HMS_LOCATION:"TSK001069",
VEHICLE:"TSK001070",
CARRIER:"TSK001071",
DSM_HEADER:"TSK001072",
DSM_SUB_HEADER:"TSK001073",
DSM_QUESTION:"TSK001074",
FOOD_MASTER:"TSK001075",
DIET_TIME_SLOT:"TSK001076",
SMS_USAGE_TRACKING:"TSK001077",
WHATSAPP_USAGE_TRACKING:"TSK001078",
EMAIL_USAGE_TRACKING:"TSK001079",

UID_GEN: "TSK001080",
MAND_SET: "TSK001081",
CASE_TEMP: "TSK001082",
MED_GST: "TSK001083",
MED_PRICE_DROP: "TSK001084",
FILE_UPLOAD: "TSK001085",
GRACE_CHG_SETUP: "TSK001086",
MANUAL_DATE_PICKER: "TSK001087",
OFFICIAL_HOLIDAY: "TSK001088",
SCHEME_TYPE: "TSK001089",



OVERALL_PRINT:'TSK100005',
PREGNANCY_SCREENING:'TSK009005',
//Master-menu
MASTER_MENU:"TSK001047",

//Triage (device-driven vitals capture) / Device Integration
TRIAGEDEVICECAPTURE:"TSK927001",
DEVICEINTEGRATION:"TSK927002",

// ASha
REFERRAL_WORKER_MASTER: "TSK202020",
REFERRAL_WORKER_COMMISSION:"TSK202021",
REFERRAL_WORKER_COMMISSION_PAYMENT: "TSK202022",
REFERRAL_WORKER_COMMISSION_APPROVAL: "TSK202023",
REFERRAL_WORKER_COMMISSION_DRAFT: "TSK202024"

},
action:{
CREATE:"New",
DELETE:"Delete",
EDIT:"Edit",
PRINT:"Print",
SHARE:"Share",
VIEW:"View",
EXPORT:"Export"

},
}